<template>
    <div class="bidding-detail-page" v-loading="detailLoading">
        <div class="bidding-head-box">
            <div class="bidding-head">
                <div class="bidding-head-left">
                    <div class="bidding-head-title">{{ detailDataLocal.websiteName || '新增投标网站' }}</div>
                    <!-- <div v-if="detailDataLocal.accountStatus"
                        :class="['bidding-status', 'bidding-' + detailDataLocal.accountStatus]">
                        {{ formatStatus(detailDataLocal.accountStatus) }}
                    </div> -->
                </div>
                <span class="bidding-head-right">
                    <lots-button  v-has="authorityCode.enable" type="primary" @click="handleEnable"
                        :loading="enableLoading" v-show="detailDataLocal.accountStatus !== 'active'">重启
                    </lots-button>
                    <lots-button v-has="authorityCode.discard" type="primary" @click="handleDiscard"
                        :loading="discardLoading" v-show="detailDataLocal.accountStatus === 'active'">废弃
                    </lots-button>
                    <lots-button v-if="isEditMode && canSave" type="primary" @click="handleSave"
                        :loading="saveLoading">保存
                    </lots-button>
                    <lots-button v-if="!isEditMode && canEdit" type="primary" @click="handleEdit">编辑
                    </lots-button>
                    <el-tooltip effect="dark" content="刷新" placement="bottom">
                        <lots-button size="mini" icon="el-icon-refresh" @click="refleshPage" :loading="detailLoading"></lots-button>
                    </el-tooltip>
                </span>
            </div>
        </div>
        <collapse-infos class="infos-content" ref="upholdHealder" :key="collapseKeys"
            :detailData="detailDataLocal" :collapse="COLLAPSE" :activeCollapses="activeCollapses"
            :addedDictKeys="addedDictKeys"  @change="handleInfosChange">
            <template v-slot:account-display="{ form, itemSetting, rIndex, collapseItem, dictData }">
                <span class="custom-span" :title="form[itemSetting.prop]">
                    {{ maskAccount(form[itemSetting.prop]) }}
                </span>
            </template>
            <template v-slot:password-display="{ form, itemSetting, rIndex, collapseItem, dictData }">
                <span class="custom-span">********</span>
            </template>
            <template v-slot:website-url-display="{ form, itemSetting, rIndex, collapseItem, dictData }">
                <a v-if="form[itemSetting.prop]" :href="form[itemSetting.prop]" target="_blank"
                    class="website-url-link">{{ form[itemSetting.prop] }}</a>
                <span v-else class="custom-span">--</span>
            </template>
            <template v-slot:collapse-append="{ form, itemSetting, rIndex, collapseItem, dictData }">
                <span v-if="!itemSetting.optionsKey" class="custom-span" :title="form[itemSetting.prop]">
                    {{ form[itemSetting.prop] ? form[itemSetting.prop] : '--' }}
                </span>
            </template>
            <template v-slot:collapse-other-append="{ form, itemSetting, rIndex, collapseItem, dictData }">
                <history-list ref="historyListRef" :detailData="detailDataLocal"></history-list>
            </template>
        </collapse-infos>
    </div>
</template>
<script>
import { ref, reactive, computed, onMounted, getCurrentInstance, watch } from '@vue/composition-api';
import _ from 'lodash';
import { Message, MessageBox } from 'element-ui';
import lotsButton from '@/components/lots/lotsButton';
import collapseInfos from '@/modules/mdm/views/contractModules/components/collapseInfos/CollapseInfos.vue';
import historyList from '@/modules/mdm/views/customerModules/biddingAccountManage/component/historyList/Index.vue';
import { collapse, addedDictKeys } from './collapseInfosConfig.js';
import { biddingAccountEnableApi, biddingAccountDiscardApi,
    biddingAccountSaveApi, getBiddingAccountDetailApi, getBiddingAccountPermissionApi } from '@/modules/mdm/api/customer/biddingAccountManage.js';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
export default {
    name: 'biddingAccountDetail',
    components: {
        lotsButton,
        collapseInfos,
        historyList
    },
    props: {
        code: {
            type: Number,
            default: 0
        },
        detailData: {
            type: Object,
            default: () => ({})
        },
        activeTabs: {
            type: String,
            default: ''
        },
        detailPageState: {
            type: String,
            default: ''
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const ctx = getCurrentInstance();
        const detailDataLocal = ref({});
        const detailLoading = ref(false);
        const saveLoading = ref(false);
        const enableLoading = ref(false);
        const discardLoading = ref(false);
        const isEditMode = ref(false);
        const authorityCode = reactive(btnAuthority.biddingAccountManage);
        const permissionData = ref({
            isSalesManager: false,
            isSystemAdmin: false,
            isAccountManager: false
        });
        const canEdit = computed(() => {
            return otherUtils.getHasAuth(btnAuthority.biddingAccountManage.edit) || permissionData.value.isAccountManager;
        });
        const canSave = computed(() => {
            return otherUtils.getHasAuth(btnAuthority.biddingAccountManage.save) || permissionData.value.isAccountManager;
        });
        const collapseKeys = computed(() => {
            return COLLAPSE.value.filter(it => it.visible).length;
        });
        const config = _.cloneDeep(collapse);
        const COLLAPSE = computed(() => { // 配置项动态计算
            // const { } = detailDataLocal.value;
            // eslint-disable-next-line max-lines-per-function
            config.forEach((v, i) => {
                // eslint-disable-next-line complexity, max-lines-per-function
                v.formList.forEach((v2, i2) => {
                    if (isEditMode.value) {
                        const inputProps = ['websiteName', 'websiteUrl', 'websiteAccount', 'accountPassword', 'registrantPhone', 'accountRegistrant'];
                        const selectProps = ['isReviewed'];
                        const advanceProps = ['accountManager', 'customerName'];
                        const canEdit = permissionData.value.isSalesManager || permissionData.value.isSystemAdmin || permissionData.value.isAccountManager;
                        const accountRegistrantEditable = canEdit;
                        const accountManagerEditable = canEdit;
                        if (inputProps.includes(v2.prop)) {
                            if (v2.prop === 'accountRegistrant') {
                                v2.type = accountRegistrantEditable ? 'input' : 'custom';
                            } else {
                                v2.type = 'input';
                            }
                        } else if (selectProps.includes(v2.prop)) {
                            v2.type = 'select';
                        } else if (advanceProps.includes(v2.prop)) {
                            if (v2.prop === 'accountManager') {
                                v2.type = accountManagerEditable ? 'advance' : 'custom';
                            } else {
                                v2.type = 'advance';
                            }
                        }
                    } else {
                        v2.type = 'custom';
                        if (v2.prop === 'websiteAccount') {
                            v2.customSlot = 'account-display';
                        } else if (v2.prop === 'accountPassword') {
                            v2.customSlot = 'password-display';
                        } else if (v2.prop === 'websiteUrl') {
                            v2.customSlot = 'website-url-display';
                        }
                    }
                });
            });
            return config;
        });
        const activeCollapses = ref(['biddingInfo', 'customerInfo', 'systemInfo', 'changeLogInfo']);
        const addedDictKeysVal = addedDictKeys;

        const maskAccount = (account) => {
            if (!account || account.length <= 4) return account;
            return account.substring(0, 2) + '***' + account.substring(account.length - 2);
        };

        const handleEdit = () => {
            isEditMode.value = true;
        };

        const handleSave = () => {
            const data = _.cloneDeep(setupContext.refs.upholdHealder.onsave());
            if (!data) return;
            const hasSpaceInPassword = data.accountPassword && /\s/.test(data.accountPassword);
            const hasSpaceInAccount = data.websiteAccount && /\s/.test(data.websiteAccount);
            if (hasSpaceInPassword || hasSpaceInAccount) {
                const confirmMsgParts = [];
                if (hasSpaceInAccount) {
                    confirmMsgParts.push(`账号存在空格`);
                }
                if (hasSpaceInPassword) {
                    confirmMsgParts.push(`密码存在空格`);
                }
                MessageBox.confirm(`${confirmMsgParts.join('、')}，请确认是否保存？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    dangerouslyUseHTMLString: true
                }).then(() => {
                    doSave(data);
                }).catch(() => {});
            } else {
                doSave(data);
            }
        };

        const doSave = (data) => {
            saveLoading.value = true;
            biddingAccountSaveApi(data).then(res => {
                saveLoading.value = false;
                if (res && +res.code === 0) {
                    Message.success('保存成功');
                    getDetailData();
                }
            }).catch(() => {
                saveLoading.value = false;
            });
        };

        const handleEnable = () => {
            enableLoading.value = true;
            biddingAccountEnableApi({ id: detailDataLocal.value.id }).then(res => {
                enableLoading.value = false;
                if (res && +res.code === 0) {
                    Message.success('重启成功');
                    getDetailData();
                }
            }).catch(() => {
                enableLoading.value = false;
            });
        };

        const handleDiscard = () => {
            MessageBox.confirm('确定要废弃该数据吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                discardLoading.value = true;
                biddingAccountDiscardApi({ id: detailDataLocal.value.id }).then(res => {
                    discardLoading.value = false;
                    if (res && +res.code === 0) {
                        Message.success('废弃成功');
                        getDetailData();
                    }
                }).catch(() => {
                    discardLoading.value = false;
                });
            }).catch(() => {});
        };

        const refleshPage = () => {
            getDetailData();
        };
        // eslint-disable-next-line max-lines-per-function, complexity
        const handleInfosChange = (formObjData = {}) => { // 表单组件编辑回调，更新本地数据
            const { itemSetting, targetForm, refName } = formObjData;
            // 监控表单是否编辑过
            if (!itemSetting) { // 页面初始化、刷新时走：
                detailDataLocal.value = Object.assign({}, formObjData.form);
                setupContext.root.$nextTick(() => {
                    setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.clearValidate(); // 重置校验报错
                    setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.refleshPage(detailDataLocal.value); // 刷新表单子组件
                    setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.updataInitData(detailDataLocal.value);
                });
            } else { // collapse组件编辑回调时走：
                const { file } = detailDataLocal.value;
                // 判断账号管理人是否变更，变更时清空账号管理人状态
                const oldAccountManager = detailDataLocal.value.accountManager;
                const newAccountManager = targetForm?.accountManager;
                if (oldAccountManager !== newAccountManager) {
                    targetForm.accountManagerStatus = undefined;
                }
                // 除了插槽参数以外，其他参数取最新编辑的参数更新(因：插槽的编辑不会触发collapse组件change事件回调，因此change事件回调的插槽的参数是旧数据不能取)
                detailDataLocal.value = Object.assign(
                    {},
                    detailDataLocal.value,
                    formObjData.form,
                    targetForm,
                    { file } // 保证插槽数据用最新的
                );
                if (targetForm && refName) {
                    const targetColl = COLLAPSE.value.find(item => item.ref === refName); // 根据最新状态清空禁用的字段
                    if (targetColl && targetColl.formList) {
                        detailDataLocal.value = Object.assign(
                            {},
                            detailDataLocal.value,
                            targetForm,
                            { file } // 保证插槽数据用最新的
                        );
                        //  这里保存的时候会触发,保存的校验比这里重置的快的话,保存的时候就不会有异常错误提示
                        // eslint-disable-next-line max-depth
                        if (itemSetting) {
                            const timer = setTimeout(() => {
                                setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.clearValidate(); // 重置校验报错
                                clearTimeout(timer);
                            });
                        }
                    }
                }
            }
        };
        const getPermissionData = () => {
            getBiddingAccountPermissionApi({}).then(res => {
                if (res && +res.code === 0) {
                    /**
                     * systemAdmin  是否是系统管理员
                     * salesManager 是否是销售管理
                     * normalSales  是否是普通营销组员  查看权限
                     * accountManager 是否是总部账号管理人
                     * */
                    // 账号管理人  总部营管和系统管理员允许修改
                    // 账号注册人   管理员特权可改
                    permissionData.value = {
                        isSalesManager: res.data?.salesManager || false,
                        isSystemAdmin: res.data?.systemAdmin || false,
                        isAccountManager: res.data?.accountManager || false
                    };
                }
            });
        };
        const getDetailData = () => {
            if (!detailDataLocal.value.id) return;
            detailLoading.value = true;
            getBiddingAccountDetailApi({ id: detailDataLocal.value.id }).then(res => {
                detailLoading.value = false;
                if (res && +res.code === 0 && res.data) {
                    detailDataLocal.value = res.data;
                    // detailDataLocal.value.accountType = res.data.accountType?.toString();
                    detailDataLocal.value.isReviewed = res.data.isReviewed?.toString();
                    isEditMode.value = false;
                    handleInfosChange({ form: formatData(detailDataLocal.value) });
                    setupContext.refs.historyListRef.getHistoryList();
                }
            }).catch(() => {
                detailLoading.value = false;
            });
        };
        // 处理详情展示数据格式
        const formatData = (data) => {
            const newData = _.cloneDeep(data);
            return newData;
        };
        watch(() => props.detailData, (newVal) => {
            if (newVal && newVal.id && newVal.id !== detailDataLocal.value.id) {
                detailDataLocal.value = { ...newVal };
                getDetailData();
            }
        }, { immediate: true });

        onMounted(() => {
            getPermissionData();
        });

        return {
            detailDataLocal,
            detailLoading,
            saveLoading,
            enableLoading,
            discardLoading,
            isEditMode,
            authorityCode,
            permissionData,
            canEdit,
            canSave,
            COLLAPSE,
            activeCollapses,
            addedDictKeys: addedDictKeysVal,
            collapseKeys,
            handleInfosChange,
            maskAccount,
            handleEdit,
            handleSave,
            handleEnable,
            handleDiscard,
            refleshPage
        };
    }
};
</script>
<style lang="less">
.bidding-detail-page {
    padding: 20px;
    background: #fff;
    height: 100%;

    .bidding-head-box {
        margin-bottom: 20px;
        padding-bottom: 15px;
        border-bottom: 1px solid #e4e7ed;
    }
    .bidding-head-right{
        min-width: 160px;
        display: flex;
        justify-content: flex-end;
    }
    .bidding-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .bidding-head-left {
        display: flex;
        align-items: center;
    }

    .bidding-head-title {
        font-size: 18px;
        font-weight: bold;
        margin-right: 15px;
    }

    .bidding-status {
        padding: 2px 10px;
        border-radius: 4px;
        font-size: 12px;

        &.bidding-0 {
            background: #909399;
            color: #fff;
        }

        &.bidding-1 {
            background: #67c23a;
            color: #fff;
        }
    }

    .detail-content {
        padding: 10px 0;
    }

    .info-row {
        display: flex;
        margin-bottom: 15px;

        .info-item {
            flex: 1;
            display: flex;
            align-items: center;
        }

        .full-width {
            width: 100%;
        }
    }

    .info-label {
        color: #909399;
        margin-right: 10px;
        flex-shrink: 0;
    }

    .info-value {
        color: #303133;
        word-break: break-all;
    }

    .custom-span {
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .website-url-link {
        color: #409EFF;
        text-decoration: none;
        &:hover {
            text-decoration: underline;
        }
    }
}
</style>
